var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false}},[_vm._v("المراجعات")]),_c('main-table',{attrs:{"baseURL":_vm.VUE_APP_MARKETPLACE_LINK,"statusUrl":'allowed-vehicle-types/status/',"fields":_vm.fields,"list_url":"admin/reviews"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }